import axios from 'axios';
// axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';


export const HTTP = axios.create({
  baseURL: "https://api.abrof.com/api/",
  headers: {
  
   "Accept": 'application/json',
   "Content-Type": 'application/json'
  }
})


